export const DEFAULT = {
    allLocations: 'ALL',
    expensesCategories: [
        'alquiler',
        'compra de productos e insumos',
        'gastos administrativos',
        'mantenimiento y reparaciones',
        'mercadeo y publicidad',
        'muebles, equipos o maquinaria',
        'nómina',
        'servicios públicos',
        'transporte, domicilios y logistica',
        'otros',
    ],
    igtf: 0.03,
    iva: 0.16,
    location: 'cualquiera',
    variation: 'cualquiera',
};
